// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v6.30.2
// source: survey-dashboard.proto

/* eslint-disable */
import type { Sort } from "./common";
import type { aggregationStep } from "./dashboard";
import type { HttpBody } from "./google/api/httpbody";
import type { Empty } from "./google/protobuf/empty";

export const protobufPackage = "proto";

export enum CsatOwner {
  ticketAssignee = "ticketAssignee",
  agentWithMostReplies = "agentWithMostReplies",
}

export enum DataDateValue {
  csatReply = "csatReply",
  ticketCreated = "ticketCreated",
  csatCreated = "csatCreated",
}

export interface CsatScores {
  scores: CsatScores_Score[];
}

export interface CsatScores_Score {
  label: string;
  normalisedScore: string;
}

export interface CsatScoresRequest {
  questionTypeId: string | undefined;
}

export interface CsatPagination {
  page: string;
  pageSize: string;
  total: string;
}

export interface CsatStatisticsRequest {
  fromDate: string | undefined;
  toDate: string | undefined;
  userIds: string[];
  connectionIds: string[];
  csatTags: string[];
  languages: string[];
  group: string;
  decimals: string;
  rawCsatScores: string[];
  csatOwnerSetting: CsatOwner;
  displayDateSetting: DataDateValue;
  page: string | undefined;
  pageSize: string | undefined;
  sort: string | undefined;
  sortAsc: boolean | undefined;
  step: aggregationStep;
  tagSource: CsatStatisticsRequest_TagSource;
  ticketTags: string[];
  csatReasons: string[];
  wordCloudWords: string[];
  channels: string[];
  predictedTags: string[];
  predictedDimensions: string[];
  breakdownSource: CsatStatisticsRequest_BreakdownSource;
  userGroups: string[];
  surveyIds: string[];
  questionTypeId: string | undefined;
  helpdesksCustomFilters: string[];
}

export enum CsatStatisticsRequest_TagSource {
  csat = "csat",
  helpdesk = "helpdesk",
}

export enum CsatStatisticsRequest_BreakdownSource {
  csatReason = "csatReason",
  helpdeskTag = "helpdeskTag",
  predictedTag = "predictedTag",
  channel = "channel",
  source = "source",
  csatLanguage = "csatLanguage",
}

export interface CsatConversationListResponse {
  items: CsatConversationListItem[];
  sort: Sort | undefined;
  pagination: CsatPagination | undefined;
}

export interface CsatConversationListItem {
  accountID: string;
  connectionId: string;
  externalId: string;
  sourceType: string;
  subject: string;
  createdAt: string | undefined;
  rawCsatScore: string | undefined;
  workspaces: string[];
}

export interface CsatOverview {
  csat: number | undefined;
  csatChange: number | undefined;
  csatValues: CsatOverview_CsatValue[];
  totalCount: string;
}

export interface CsatOverview_CsatValue {
  label: string;
  normalisedScore: string;
  value: number;
  change: number | undefined;
  count: string;
}

export interface CsatSurveyFunnel {
  conversations: CsatSurveyFunnel_Value | undefined;
  surveys: CsatSurveyFunnel_Value | undefined;
  responses: CsatSurveyFunnel_Value | undefined;
  comments: CsatSurveyFunnel_Value | undefined;
}

export interface CsatSurveyFunnel_Value {
  count: string;
  relative: number | undefined;
  change: number | undefined;
  notApplicable: boolean;
}

export interface CsatPerAgentResponse {
  agentStatistics: CsatPerAgent[];
  sort: Sort | undefined;
  pagination: CsatPagination | undefined;
}

export interface CsatPerAgent {
  agentId: string;
  agentName: string;
  agentAvatar: string | undefined;
  tickets: string;
  csatTickets: string;
  responseRate: CsatPerAgent_Value | undefined;
  csat: CsatPerAgent_Value | undefined;
  agentEmail: string;
}

export interface CsatPerAgent_Value {
  value: number | undefined;
  change: number | undefined;
}

export interface CsatBreakdownResponse {
  breakdownStatistics: CsatBreakdown[];
  sort: Sort | undefined;
  pagination: CsatPagination | undefined;
}

export interface CsatBreakdown {
  label: string | undefined;
  tickets: string | undefined;
  csatTickets: string;
  responseRate: CsatBreakdown_Value | undefined;
  csat: CsatBreakdown_Value | undefined;
}

export interface CsatBreakdown_Value {
  value: number | undefined;
  change: number | undefined;
}

export interface CsatTimeline {
  labels: string[];
  workspaces: CsatTimeline_WorkspaceCSAT[];
  averageCsat: Array<any> | undefined;
  totalResponses: string[];
}

export interface CsatTimeline_CsatValue {
  label: string;
  normalisedScore: string;
  count: string;
  value: number;
}

export interface CsatTimeline_Data {
  values: CsatTimeline_CsatValue[];
}

export interface CsatTimeline_WorkspaceCSAT {
  id: string;
  csat: Array<any> | undefined;
  responses: string[];
  details: CsatTimeline_Data[];
}

export interface CsatTimelineWithIQS {
  labels: string[];
  workspaces: CsatTimelineWithIQS_WorkspaceCSAT[];
  averageCsat: Array<any> | undefined;
  totalResponses: string[];
  averageScores: Array<any> | undefined;
  totalReviews: number[];
}

export interface CsatTimelineWithIQS_WorkspaceCSAT {
  id: string;
  csat: Array<any> | undefined;
  responses: string[];
  details: CsatTimeline_Data[];
  scores: Array<any> | undefined;
  reviews: number[];
}

export interface CsatTimelineBreakdown {
  labels: string[];
  averageCsat: Array<any> | undefined;
  totalResponses: string[];
  breakdown: CsatTimelineBreakdown_CsatBreakdown[];
  averageScores: Array<any> | undefined;
  totalReviews: number[];
}

export interface CsatTimelineBreakdown_CsatBreakdown {
  label: string | undefined;
  data: CsatTimeline | undefined;
}

export interface CsatWordCloud {
  words: CsatWordCloud_word[];
  conversationCount: string;
}

export interface CsatWordCloud_word {
  label: string;
  value: string;
}

export interface CsatCommentListResponse {
  items: CsatCommentListItem[];
  sort: Sort | undefined;
  pagination: CsatPagination | undefined;
}

export interface CsatCommentListItem {
  connectionId: string;
  conversationExternalId: string;
  connectionType: string;
  csatCreatedAt: string | undefined;
  agentId: string | undefined;
  agentAvatar: string | undefined;
  agentName: string | undefined;
  comment: string | undefined;
  rawCsatScore: string | undefined;
  commentSize: string | undefined;
  commentCategory: string[];
  workspaces: string[];
}

export interface CsatTags {
  tags: CsatTags_tag[];
  conversationCount: string;
  conversationsWithTags: string;
}

export interface CsatTags_tag {
  label: string;
  value: string;
}

export interface CsatLanguageRequest {
  surveyIds: string[];
  questionTypeId: string | undefined;
}

export interface CsatReasonRequest {
  searchString: string;
  limit: string;
  surveyIds: string[];
  questionTypeId: string | undefined;
}

export interface FilterRequest {
  searchString: string;
  limit: string;
  questionTypeId: string | undefined;
}

export interface FilterResponse {
  values: string[];
  total: string;
}

export interface CsatDashboard {
  /** GetCsatDashboardScores returns distinct csat values */
  GetCsatDashboardScores(request: CsatScoresRequest): Promise<CsatScores>;
  /** GetCsatDashboardTickets returns csat conversations */
  GetCsatDashboardTickets(request: CsatStatisticsRequest): Promise<CsatConversationListResponse>;
  /** GetCsatDashboardOverview returns csat overview */
  GetCsatDashboardOverview(request: CsatStatisticsRequest): Promise<CsatOverview>;
  /** GetCsatDashboardSurveyFunnel returns survey funnel data */
  GetCsatDashboardSurveyFunnel(request: CsatStatisticsRequest): Promise<CsatSurveyFunnel>;
  /** GetCsatByAgent returns per agent csat data */
  GetCsatByAgent(request: CsatStatisticsRequest): Promise<CsatPerAgentResponse>;
  /** GetCsatDashboardTimelineWithIQS returns csat data over a time period */
  GetCsatDashboardTimelineWithIQS(request: CsatStatisticsRequest): Promise<CsatTimelineWithIQS>;
  /** GetCsatDashboardTimeline returns csat data over a time period including IQS data */
  GetCsatDashboardTimeline(request: CsatStatisticsRequest): Promise<CsatTimeline>;
  /** GetCsatDashboardTimelineBreakdown returns csat timeline breakdown data over a time period */
  GetCsatDashboardTimelineBreakdown(request: CsatStatisticsRequest): Promise<CsatTimelineBreakdown>;
  /** GetCsatDashboardWordCloud returns most used words in csat comments */
  GetCsatDashboardWordCloud(request: CsatStatisticsRequest): Promise<CsatWordCloud>;
  /** GetCsatDashboardComments returns csat list */
  GetCsatDashboardComments(request: CsatStatisticsRequest): Promise<CsatCommentListResponse>;
  /** GetCsatDashboardTags returns csat tags */
  GetCsatDashboardTags(request: CsatStatisticsRequest): Promise<CsatTags>;
  /** GetCsatLanguages returns csat languages */
  GetCsatLanguages(request: CsatLanguageRequest): Promise<FilterResponse>;
  /** GetCsatReasons returns csat reasons */
  GetCsatReasons(request: CsatReasonRequest): Promise<FilterResponse>;
  /** GetCsatWordCloudWords returns words from word cloud */
  GetCsatWordCloudWords(request: FilterRequest): Promise<FilterResponse>;
  /** GetCsatPredictedTags returns csat predicted tags */
  GetCsatPredictedTags(request: Empty): Promise<FilterResponse>;
  /** GetCsatPredictedDimensions returns csat predicted dimensions */
  GetCsatPredictedDimensions(request: Empty): Promise<FilterResponse>;
  /** GetCsatBreakdown returns csat statistics per breakdown source */
  GetCsatBreakdown(request: CsatStatisticsRequest): Promise<CsatBreakdownResponse>;
  /** ExportCsatCSV returns download link for csat statistics for given request */
  ExportCsatCSV(request: CsatStatisticsRequest): Promise<HttpBody>;
}
